// import React from 'react'
import './UXcasestudies.css'
import images from '../images/Imac_whiteMockup.png'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFigma } from '@fortawesome/free-brands-svg-icons/faFigma';
// import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { Link } from 'react-router-dom';
// import Navbar from './Navbar';
// import HeroSection from './HeroSection';
// import Footer from './Footer';



// import imagesanalytics from '../images/CloudAnalyticsMockup.png'


const UXcasestudies = () => {
  return (
     <>
     

    <div id="UXContainer"> 

            <div className='HeadingUX' >UX case studies</div>


        <div id="AllProjects"> 

            <div id="FirstProject">

                <div id="ImgProject">
                    <img className='PrjImg' src={images} alt="" />
                </div>
                

                    <div id="BoxContent" >
                     <h3 className='BoxHeading' >FirstVoices</h3>

                        <div className="BoxCopy" >
                            <p>
                                <span className="Box-subhead"> Summary:</span> Firstvoices is a educational website used by indigenous nations of BC canada.
                            </p> 
                                <br />

                            <p>
                            <span className="Box-subhead"> Impact:</span> Increased ease of use of the website for end user and language teams. Conducted User Interviews and User research surveys. Created and managed design system. 
                            </p> 
                            <br />

                            <p>
                            <span className="Box-subhead"> Methods:</span> User research, user persona, user flow, user testing, information architecture, 
                            journey mapping, prototype design, and front-end development.
                            </p> 
                            <br />
                        </div>

                            <Link className='ProjectCTA' to="/FiirstVoicess"> 
                                Read case study
                            </Link>                      
                    </div>
            </div>
                
            <div id="FirstProject">

                <div id="ImgProject">
                    <img className='PrjImg' src={images} alt="" />
                </div>
                

                    <div id="BoxContent" >
                     <h3 className='BoxHeading' >Cloud Marketplace Platform</h3>

                        <div className="BoxCopy" >
                            <p>
                                <span className="Box-subhead"> Summary:</span> The Cloud Marketplace is a digital storefront where customers 
                                can instantly purchase cloud subscriptions and licenses.
                            </p> 
                                <br />

                            <p>
                            <span className="Box-subhead"> Impact:</span> 40% increase in year-over-year revenue and 50% click rate achieved 
                            by implementing a new feature
                            </p> 
                            <br />

                            <p>
                            <span className="Box-subhead"> Methods:</span> User research, user persona, user flow, user testing, information architecture, 
                            journey mapping, prototype design, and front-end development.
                            </p> 
                            <br />
                        </div>

                            <Link className='ProjectCTA' to="/marketplace"> 
                                Read case study
                            </Link>  
  
                        
                    </div>

            </div>


            <div id="SecondProject">

                <div id="ImgProjectSecond">
                    <img className='PrjImgSecond' src={images} alt="" />
                </div>
                

                    <div id="BoxContentSecond" >
                     <h3 className='BoxHeadingSecond' >Cloud Analytics Platform</h3>

                        <div className="BoxCopySecond" >
                            <p>
                                <span className="Box-subheadSecond"> Summary:</span> The cloud analytics platform offers real-time insights into customer cloud consumption and journey for stakeholders.


                            </p> 
                                <br />

                            <p>
                            <span className="Box-subheadSecond"> Impact:</span> 50% reduction in time required to access 
                            reports and 35% increased efficiency in cross-team collaboration.
                            </p> 
                            <br />

                            <p>
                            <span className="Box-subheadSecond"> Methods:</span> User persona, user research, user flow, 
                            user testing, information architecture, affinity mapping, and interface design.
                            </p> 
                            <br />
                        </div>

                        
                        <div> 
                            <Link className='ProjectCTA' to='/analyticsdashboard'>
                            Read case study
                            </Link>
                        </div>
                        
                    </div>

            </div>



            <div id="ThirdProject">

                <div id="ImgProjectThird">
                    <img className='PrjImgThird' src={images} alt=""/>
                </div>
                

                    <div id="BoxContentThird">
                     <h3 className='BoxHeadingThird' >E-Commerce Website Re-Design</h3>

                        <div className="BoxCopyThird">
                            <p>
                                <span className="Box-subheadThird"> Summary:</span> TAG Hardware is a hardware 
                                store that sells glass shower door hardware and glass railing hardware 
                                to contractors and distributors.
                            </p> 

                                <br />

                            <p>
                            <span className="Box-subheadThird"> Impact:</span> Increased conversion rate by 51% and 
                            Increased online revenue by 47%.
                            </p> 
                            <br />

                            <p>
                            <span className="Box-subheadThird"> Methods:</span> User research, user persona, user flow, 
                            user testing, information architecture, SWOT analysis, competitive analysis, wireframes, 
                            prototype and interface design.
                            </p> 
                            <br />
                        </div>

               
                        <div>
                            <Link className='ProjectCTA' to ='/ecommercewebsite'> 
                             Read case study 
                            </Link>
                            
                        </div>
                        
                    </div>

            </div>














        </div>

        <div id="emptyColor"></div>



    </div>


    {/* <Footer /> */}
    

    </>

  )
}

export default UXcasestudies